import { CREATEIPDOPERATION, DELETEIPDOPERATION, GETIPDOPERATION, UPDATEIPDOPERATION } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEIPDOPERATION:
            return {
                ...state,
                ipdoperationSaveStatus: action.payload.success,
            }
        case GETIPDOPERATION:
                return {
                        ...state,
                        ipdoperationList: action.payload.data,
                        }
        case UPDATEIPDOPERATION:
                return {
                        ...state,
                        ipdoperationUpdateStatus: action.payload.success,
                        }   

        case DELETEIPDOPERATION:
                 return {
                     ...state,
                     ipdoperationDeleteStatus: action.payload.success,
                        } 

                        default:
                            return state
                             }
                         }